export const getCurrentPageStep = (routes, pathname) =>
  routes.find((route) => route.routes.includes(pathname))?.step || -1;

export const getCurrentProgress = (step, total) => (step / total) * 100;
